export default "__VITE_ASSET__DzfXOvga__"